enum AllocationEditTypeEnum {
  EDIT = "edit",
  ADD_CHILD = "ADD_CHILD",
  NEW = "new",
  NEW_WITH_TYPE = "newWithType",
}

export default AllocationEditTypeEnum;
